import React from "react";

interface TransactionAmountCellProps {
  amount?: string | number | null;
  totalFee?: string | number | null;
}

const formatNaira = (value: number) =>
  `₦${value.toLocaleString("en-NG", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

// Debits that carry a fee (total_fee > 0) render as two lines: the amount
// debited, then a smaller "Fee" line underneath. Credits and fee-less debits
// keep the original single-line display untouched.
const TransactionAmountCell: React.FC<TransactionAmountCellProps> = ({
  amount,
  totalFee,
}) => {
  if (amount === undefined || amount === null || amount === "") return <>-</>;

  const amountNum = Number(amount);
  const feeNum = Number(totalFee ?? 0);

  if (feeNum > 0) {
    return (
      <div>
        <div>-{formatNaira(amountNum)}</div>
        <div className="text-xs text-red-500">Fee -{formatNaira(feeNum)}</div>
      </div>
    );
  }

  return <>₦{amountNum.toLocaleString("en-NG")}</>;
};

export default TransactionAmountCell;
